import { render, staticRenderFns } from "./ClientContactsImport.vue?vue&type=template&id=25566fc0&"
import script from "./ClientContactsImport.vue?vue&type=script&lang=js&"
export * from "./ClientContactsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports